import { useLocation } from "react-router-dom";

import { getPublicConfig } from "../../api/config/getPublicConfig";
import { PageDirectoryEntryName } from "../../api/PageDirectory";
import { getAPExternalClientURL } from "../../helpers/configuration";
import { DossierStatusGroup } from "../../types/Dossier";
import CopyUrlField from "./CopyUrlField";

type CopyGenericDossierUrlFieldProps = {
  destination: PageDirectoryEntryName;
  statusRestriction: DossierStatusGroup | null;
  text: string;
  secondaryId?: string;
  excludeSearchParams?: string[];
};

const CopyGenericDossierUrlField = ({
  destination,
  secondaryId,
  statusRestriction,
  text,
  excludeSearchParams,
}: CopyGenericDossierUrlFieldProps) => {
  const location = useLocation();
  const configMap = getPublicConfig();

  const hostUrl = configMap.isSuccess
    ? getAPExternalClientURL(configMap.data)
    : null;
  const searchParams = new URLSearchParams(location.search);

  searchParams.delete("quoteId");

  if (excludeSearchParams) {
    excludeSearchParams.forEach((param) => {
      searchParams.delete(param);
    });
  }

  if (secondaryId) {
    searchParams.set("secondaryId", secondaryId);
  }
  if (statusRestriction) {
    searchParams.set("status", statusRestriction);
  }

  const path = `/latest-dossier/${destination}${
    searchParams.size > 0 ? `?${searchParams.toString()}` : ""
  }`;

  const url = hostUrl ? `${hostUrl}${path}` : null;

  return url ? <CopyUrlField copyText={text} url={url} /> : <></>;
};

export default CopyGenericDossierUrlField;
